module.exports = __webpack_public_path__ + "static/media/biblioteket.0520cbb5.mp3";